import type { IComponentOptions } from "angular";
import { ButtonComponent } from "App/Modules/Gui/Components/Button/Common/ButtonComponent";
import { ButtonComponentController } from "../Common/ButtonComponentController";

import "../Common/Button.scss";
import "./DeleteButton.html";
import "./DeleteButton.scss";

export class DeleteButtonComponent extends ButtonComponent implements IComponentOptions {
    public controller = ButtonComponentController;

    public templateUrl = "/App/Modules/Gui/Components/Button/DeleteButton/DeleteButton.html";
}
